/**
 * Resolves KPI grid classes without stacking `--one` / `--two` / `--three` /
 * `--four` / `--five` / `--six`.
 * Callers that pass a column modifier must not also keep `--six` (CSS order would
 * leave an empty trailing column and left-pack the strip).
 * Single / dual strips use `--one` / `--two` (1-col stretch; `--two` always 2-col).
 * Tx strip uses `--four` (2-col wrap under compact / Spec §8.3; 4-up ≥1024; no H-scroll invent; min-height 84, grows with labels).
 * Aggregates worker strip uses `--three` (1→3; never inherit empty `--six` tracks).
 */
export function resolveKpiGridClassName(className?: string): string {
  const extra = className?.trim() ?? '';
  const hasOne = /(?:^|\s)an-kpi-grid--one(?:\s|$)/.test(extra);
  const hasTwo = /(?:^|\s)an-kpi-grid--two(?:\s|$)/.test(extra);
  const hasThree = /(?:^|\s)an-kpi-grid--three(?:\s|$)/.test(extra);
  const hasThreeFull = /(?:^|\s)an-kpi-grid--three-full(?:\s|$)/.test(extra);
  const hasFour = /(?:^|\s)an-kpi-grid--four(?:\s|$)/.test(extra);
  const hasFourFull = /(?:^|\s)an-kpi-grid--four-full(?:\s|$)/.test(extra);
  const hasFive = /(?:^|\s)an-kpi-grid--five(?:\s|$)/.test(extra);
  const hasSix = /(?:^|\s)an-kpi-grid--six(?:\s|$)/.test(extra);
  /* Do not treat `an-kpi-grid--five` / `--four` as the base `an-kpi-grid` token. */
  const hasBase = /(?:^|\s)an-kpi-grid(?:\s|$)/.test(extra);

  const parts: string[] = [];
  if (!hasBase) {
    parts.push('an-kpi-grid');
  }
  if (!hasOne && !hasTwo && !hasThree && !hasThreeFull && !hasFour && !hasFourFull && !hasFive && !hasSix) {
    parts.push('an-kpi-grid--six');
  }
  if (extra.length > 0) {
    parts.push(extra);
  }
  return parts.join(' ');
}
